import { useShowNotification } from '@inflearn/ds-react';
import {
  DEFAULT_MAX_IMAGE_SIZE,
  InflearnEditorStarterKit,
  useTiptapEditor,
} from '@inflearn/editor';

import useFilePostImageCreateMutation from '../mutations/useFilePostImageCreateMutation';

interface EditorParams {
  disabled?: boolean;
  initialValue?: string;
  placeholder?: string;
  onChange?: (body: string) => void;
}

export const useEditor = ({
  onChange,
  disabled = false,
  initialValue = '',
  placeholder = '',
}: EditorParams = {}) => {
  const { uploadImageForEditor } = useFilePostImageCreateMutation();
  const { showNotification } = useShowNotification();

  return useTiptapEditor({
    editable: !disabled,
    content: initialValue,
    extensions: [
      InflearnEditorStarterKit.configure({
        placeholder: {
          placeholder,
        },
        image: {
          showNotification,
          maxImageSize: DEFAULT_MAX_IMAGE_SIZE,
          uploadFormData: uploadImageForEditor,
        },
        textAlign: {
          defaultAlignment: 'left',
          types: ['paragraph', 'heading'],
        },
        link: {
          openOnClick: false,
        },
      }),
    ],
    onUpdate: ({ editor }) => onChange?.(editor.getHTML() || ''),
  });
};
